import { createContext, useContext } from "react";

const OrganisationContext = createContext({});
OrganisationContext.displayName = "Organisation";

export const useOrganisation = () =>
    useContext(OrganisationContext).organisation;

export const OrganisationProvider = OrganisationContext.Provider;
